import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=7ef4feb7&scoped=true&"
import script from "./layouts.vue?vue&type=script&lang=js&"
export * from "./layouts.vue?vue&type=script&lang=js&"
import style0 from "./layouts.vue?vue&type=style&index=0&id=7ef4feb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4feb7",
  null
  
)

export default component.exports